<template>
  <div>
    <!--<template v-if="backendError">-->
      <!--<p class="headline text-xs-center red&#45;&#45;text">-->
        <!--<v-icon color="red" size="50px">error_outline</v-icon><br/>-->
        <!--Server Error: {{ backendError.message }}-->
      <!--</p>-->
    <!--</template>-->
    <!--<template v-else>-->

      <!-- Start toolbar -->
      <v-toolbar color="white" floating dense flat absolute top style="margin-top: 70px; float: right;" class="elevation-6">
        <!--<v-layout row wrap justify-center>-->
          <!--<v-flex xs12 sm6 text-xs-center>-->
            <v-btn-toggle v-model="toolbar" mandatory>
              <v-btn flat value="select">
                <span>Select</span>
                <v-icon>select_all</v-icon>
              </v-btn>
              <v-btn flat value="seat">
                <span>Seat</span>
                <v-icon>event_seat</v-icon>
              </v-btn>
              <v-btn flat value="screen">
                <span>Screen</span>
                <v-icon>format_shapes</v-icon>
              </v-btn>
              <v-btn flat value="wall">
                <span>Wall</span>
                <v-icon>format_shapes</v-icon>
              </v-btn>
              <v-btn flat value="railing">
                <span>Railing</span>
                <v-icon>format_shapes</v-icon>
              </v-btn>
              <v-btn flat value="text">
                <span>Text</span>
                <v-icon>short_text</v-icon>
              </v-btn>
            </v-btn-toggle>
          <!--</v-flex>-->
        <!--</v-layout>-->
        <v-divider
                class="mx-3"
                inset
                vertical
        ></v-divider>
        <v-switch label="Score View"
                  value input-value="true"
                  v-model="scoreView"
                  color="blue-grey darken-4"
                  class="mt-3"
        ></v-switch>
      </v-toolbar>
      <!-- End toolbar -->

      <!-- Start designer canvas -->
      <div class="c-canvas"
           :style="{ 'width': canvasWidth + 'px', 'height': canvasHeight + 'px' }"
           @click.self="canvasClickAction($event)"
      >
        <c-seat v-for="(slot, index) in slots"
                :key="'st'+index"
                :my-seat="slot"
                :booking-mode="false"
                @seat-moved="uiComponentMoved($event, slot)"
                @show-seat-context-menu="showContextMenu($event, slot, 'seat')"
                @show-seat-details="showItemDetailMenu($event, slot, index, 'seat')"
                :score-view="scoreView"
                :edit-selected="slot.editSelected"
                @add-seat-to-selection="addToSelection(slot, index)"
        ></c-seat>

        <template v-for="(uiComponent, index) in uiComponents">
          <c-screen v-if="uiComponent.type === 'SCREEN'"
                    :key="'sc'+index"
                    :my-screen="uiComponent"
                    @screen-moved="uiComponentMoved($event, uiComponent)"
                    @show-screen-context-menu="showContextMenu($event, uiComponent, 'screen')"
          ></c-screen>
          <c-wall v-else-if="uiComponent.type === 'WALL'"
                    :key="'wl'+index"
                    :my-wall="uiComponent"
                    @wall-moved="uiComponentMoved($event, uiComponent)"
                    @show-wall-context-menu="showContextMenu($event, uiComponent, 'wall')"
          ></c-wall>
          <c-railing v-else-if="uiComponent.type === 'RAILING'"
                  :key="'rl'+index"
                  :my-railing="uiComponent"
                  @railing-moved="uiComponentMoved($event, uiComponent)"
                  @show-railing-context-menu="showContextMenu($event, uiComponent, 'railing')"
          ></c-railing>
          <c-ui-text v-else-if="uiComponent.type === 'TEXT'"
                     :key="'txt'+index"
                     :my-text="uiComponent"
                     @text-moved="uiComponentMoved($event, uiComponent)"
                     @show-ui-text-context-menu="showContextMenu($event, uiComponent, 'text')"
                     @show-ui-text-details="showItemDetailMenu($event, uiComponent, index, 'text')"
          ></c-ui-text>
        </template>

        <!-- Context menu -->
        <v-menu
          v-model="showMenu"
          :position-x="cmX"
          :position-y="cmY"
          offset-y
          absolute
        >
          <v-list>
            <v-list-tile v-for="(item, index) in seatCM" :key="'mnu'+index" @click="seatCMAction(selectedItem, item.menuAction)">
              <v-list-tile-action v-if="item.icon !== ''">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!-- End context menu -->

        <!-- Selected item details menu -->
        <div class="selected-item-details elevation-6"
             v-show="showItemDetails"
        >
          <v-card>
            <v-card-text>
              <v-container grid-list-md class="px-0 mx-0 py-0">
                <v-layout wrap>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-text-field
                            v-model="multiSelectedItem.rowLabel"
                            :counter="2"
                            maxlength="2"
                            label="Row"
                            @blur="validateSeatNames(selectedItem)"
                            @keyup="updateMultipleItems('rowLabel')"
                            required
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-text-field
                            v-model="selectedItem.rowLabel"
                            :counter="2"
                            maxlength="2"
                            label="Row"
                            @blur="validateSeatNames(selectedItem)"
                            required
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-text-field
                            :counter="3"
                            maxlength="3"
                            label="Slot Number"
                            disabled
                            required
                    ></v-text-field> <!-- mask="###" -->
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-text-field
                            v-model="selectedItem.slotNumber"
                            :counter="3"
                            maxlength="3"
                            label="Slot Number"
                            @blur="validateSeatNames(selectedItem)"
                            :disabled="isMultiAssignable"
                            required
                    ></v-text-field> <!-- mask="###" -->
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-select
                            :items="slotCategories"
                            item-text="name"
                            item-value="id"
                            v-model="multiSelectedItem.slotCategory.id"
                            label="Category"
                            @change="updateMultipleItems('slotCategory')"
                            auto
                    ></v-select>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-select
                            :items="slotCategories"
                            item-text="name"
                            item-value="id"
                            v-model="selectedItem.slotCategory.id"
                            label="Category"
                            auto
                    ></v-select>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-select
                            :items="slotStatuses"
                            v-model="multiSelectedItem.status"
                            label="Status"
                            @change="updateMultipleItems('status')"
                            auto
                    ></v-select>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-select
                            :items="slotStatuses"
                            v-model="selectedItem.status"
                            label="Status"
                            auto
                    ></v-select>
                  </v-flex>
                  <v-flex v-if="isSeatUnderRepair && isMultiAssignable" xs6>
                    <v-menu
                            ref="repairStartDateMenu"
                            lazy
                            :close-on-content-click="false"
                            v-model="repairStartDateMenu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="multiSelectedItem.repairStartDate"
                    >
                      <v-text-field
                              slot="activator"
                              label="From"
                              v-model="multiSelectedItem.repairStartDate"
                              prepend-icon="event"
                              @change="updateMultipleItems('repairStartDate')"
                              required
                              readonly
                      ></v-text-field>
                      <v-date-picker v-model="multiSelectedItem.repairStartDate"
                                     no-title
                                     scrollable
                      >
                        <v-btn flat color="primary" @click="repairStartDateMenu = false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                flat
                                color="primary"
                                @click="$refs.repairStartDateMenu.save(multiSelectedItem.repairStartDate)"
                        >OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex v-else-if="isSeatUnderRepair" xs6>
                    <v-menu
                            ref="repairStartDateMenu"
                            lazy
                            :close-on-content-click="false"
                            v-model="repairStartDateMenu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="selectedItem.repairStartDate"
                    >
                      <v-text-field
                              slot="activator"
                              label="From"
                              v-model="selectedItem.repairStartDate"
                              prepend-icon="event"
                              required
                              readonly
                      ></v-text-field>
                      <v-date-picker v-model="selectedItem.repairStartDate"
                                     no-title
                                     scrollable
                      >
                        <v-btn flat color="primary" @click="repairStartDateMenu = false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                flat
                                color="primary"
                                @click="$refs.repairStartDateMenu.save(selectedItem.repairStartDate)"
                        >OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex v-if="isSeatUnderRepair && isMultiAssignable" xs6>
                    <v-menu
                            ref="repairEndDateMenu"
                            lazy
                            :close-on-content-click="false"
                            v-model="repairEndDateMenu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="multiSelectedItem.repairEndDate"
                    >
                      <v-text-field
                              slot="activator"
                              label="To"
                              v-model="multiSelectedItem.repairEndDate"
                              prepend-icon="event"
                              @change="updateMultipleItems('repairEndDate')"
                              required
                              readonly
                      ></v-text-field>
                      <v-date-picker
                              v-model="multiSelectedItem.repairEndDate"
                              no-title
                              scrollable
                      >
                        <v-btn flat color="primary" @click="repairEndDateMenu = false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                flat
                                color="primary"
                                @click="$refs.repairEndDateMenu.save(multiSelectedItem.repairEndDate)"
                        >OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex v-else-if="isSeatUnderRepair" xs6>
                    <v-menu
                            ref="repairEndDateMenu"
                            lazy
                            :close-on-content-click="false"
                            v-model="repairEndDateMenu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="selectedItem.repairEndDate"
                    >
                      <v-text-field
                              slot="activator"
                              label="To"
                              v-model="selectedItem.repairEndDate"
                              prepend-icon="event"
                              required
                              readonly
                      ></v-text-field>
                      <v-date-picker
                              v-model="selectedItem.repairEndDate"
                              no-title
                              scrollable
                      >
                        <v-btn flat color="primary" @click="repairEndDateMenu = false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                flat
                                color="primary"
                                @click="$refs.repairEndDateMenu.save(selectedItem.repairEndDate)"
                        >OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-select
                            :items="slotCapacities" v-model="multiSelectedItem.capacity"
                            label="Capacity" item-text="text" item-value="capacity"
                            @change="updateMultipleItems('capacity')"
                            auto
                    ></v-select>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-select
                            :items="slotCapacities" v-model="selectedItem.capacity"
                            label="Capacity" item-text="text" item-value="capacity"
                            auto
                    ></v-select>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-text-field
                            v-model="multiSelectedItem.zone"
                            @keyup="updateMultipleItems('zone')"
                            label="Zone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-text-field
                            v-model="selectedItem.zone"
                            label="Zone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-text-field
                            v-model="multiSelectedItem.slotScore"
                            @keyup="updateMultipleItems('slotScore')"
                            type="number"
                            label="Seat Score"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-text-field
                            v-model="selectedItem.slotScore"
                            type="number"
                            label="Seat Score"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-switch
                            label="Happy Seat"
                            v-model="multiSelectedItem.managerReserved"
                            @change="updateMultipleItems('managerReserved')"
                            :false-value="0"
                            :true-value="1"
                    ></v-switch>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-switch
                            label="Happy Seat"
                            v-model="selectedItem.managerReserved"
                            :false-value="0"
                            :true-value="1"
                    ></v-switch>
                  </v-flex>
                  <v-flex v-if="isUITextField && isMultiAssignable" xs12>
                    <v-text-field
                            v-model="multiSelectedItem.label"
                            @keyup="updateMultipleItems('label')"
                            label="Text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-else-if="isUITextField" xs12>
                    <v-text-field
                            v-model="selectedItem.label"
                            label="Text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="isSeatField && isMultiAssignable" xs6>
                    <v-text-field
                      v-model="multiSelectedItem.technicalName"
                      label="Technical Name"
                      @keyup="updateMultipleItems('technicalName')"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-else-if="isSeatField" xs6>
                    <v-text-field
                      v-model="selectedItem.technicalName"
                      label="Technical Name"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </div>
        <!--<v-menu-->
          <!--:position-x="iDetX"-->
          <!--:position-y="iDetY"-->
          <!--offset-y-->
          <!--absolute-->

          <!--:close-on-content-click="false"-->
          <!--:nudge-width="200"-->
          <!--offset-x-->
        <!--&gt;-->
          <!--<v-card>-->
            <!--<v-card-text>-->
              <!--&lt;!&ndash; Start selected item details color="transparent" &ndash;&gt;-->
              <!--<v-form-->
                <!--:style="{ 'width': detailSectionWidth + 'px' }"-->
              <!--&gt;-->

              <!--</v-form>-->
              <!--&lt;!&ndash; End selected item details&ndash;&gt;-->
            <!--</v-card-text>-->
          <!--</v-card>-->
        <!--</v-menu>-->
        <!-- End Selected item details menu -->

      </div>
      <!-- End canvas -->

    <!--</template>-->
  </div>
</template>

<script>
  export default {
    name: "FloorPlanDesigner",
    props: {
      selectedLayout: Object,
      canvasWidth: Number,
      canvasHeight: Number,
      triggerSave: Boolean,
      designerModalClosed: Boolean
    },

    data: () => ({
      backendError: null,
      toolbar: 'select',

      showMenu: false,
      showItemDetails: false,
      cmX: 0,
      iDetX: 0,
      cmY: 0,
      iDetY: 0,
      detailSectionWidth: 250,
      selectedItem: {},
      multiSelectedItem: { slotCategory: { id: null } },
      defaultMultiSelectedItem: { slotCategory: { id: null } },
      selectedItemArray: [],
      selectedIndex: -1,
      selectedIndexArray: [],
      multiSelectedIndexes: [],
      selectedItemType: '',
      slotCategories: [],
      slotStatuses: [ 'BROKEN', 'ACTIVE' ],
      slotCapacities: [
        { capacity: 1, text: 'SINGLE' },
        { capacity: 2, text: 'SOFA' }
      ],
      seatCM: [
        { title: 'Delete', menuAction: 'delete', icon: 'delete' }
      ],
      deletedSlots: [],
      deletedUiComponents: [],
      repairStartDateMenu: false,
      repairEndDateMenu: false,
      scoreView: false
    }),

    computed: {
      detailSectionX() {
        return window.innerWidth - this.detailSectionWidth - 75;
      },
      isSeatField() {
        return this.selectedItemType === 'seat';
      },
      isUITextField() {
        return this.selectedItemType === 'text';
      },
      isScreenField() {
        return this.selectedItemType === 'screen';
      },
      isSeatUnderRepair() {
        return this.isSeatField && this.selectedItem.status === 'BROKEN';
      },
      slots() {
        return (this.selectedLayout) ? this.selectedLayout.slots : [];
      },
      uiComponents() {
        return (this.selectedLayout) ? this.selectedLayout.uiComponents : [];
      },
      isMultiAssignable() {
        return this.multiSelectedIndexes.length > 0;
      }
    },

    watch: {
      triggerSave (newValue) {
        // console.log('new value = ' + newValue);
        if (newValue) {
          this.saveLayoutComponents();
        }
      },
      designerModalClosed (val) {
        if (val) {
          this.showItemDetails = false;
        }
      },
      multiSelectedIndexes (newVal, oldVal) {
        if (oldVal.length > 0) {
          oldVal.forEach(slotIndex => {
            this.setEditSelected(slotIndex, false);
          });
        }
        if (newVal.length > 0) {
          newVal.forEach(slotIndex => {
            this.setEditSelected(slotIndex, true);
          });
        }
      }
    },

    methods: {
      // Save All the components on the canvas
      saveLayoutComponents() {
        let componentWrapper = {
          slots: this.slots,
          uiComponents: this.uiComponents,
          deletedSlots: this.deletedSlots,
          deletedUiComponents: this.deletedUiComponents
        };
        // console.log(componentWrapper);

        axios.post(BACKEND_URL+'/api/layouts/'+this.selectedLayout.id+'/save-components', componentWrapper).then(({data})=>{
          this.$emit('layout-components-saved', data);
          // console.log(data);
        }).catch((error)=>{
          if (error.message === 'Network Error') {
            // console.log('Cannot connect to server');
            this.backendError = {};
            this.backendError.message = 'Cannot connect to server';
          } else {
            // console.log(error);
            this.backendError = error.response.data;
          }
          this.$emit('reset-save-btn');
        });
      },

      // Canvas click actions
      canvasClickAction(clickEvent) {
        if (this.toolbar === 'seat') {
          this.selectedItem = this.createSeat(clickEvent.offsetX, clickEvent.offsetY);
          this.selectedIndex = this.slots.indexOf(this.selectedItem);
          this.trackSelectedSlots();
          this.trackSelectedSlotIndexes();
          this.selectedItemType = 'seat';
        } else if (this.toolbar === 'screen') {
          this.selectedItem = this.createScreen(clickEvent.offsetX, clickEvent.offsetY);
          this.selectedItemType = 'screen';
        } else if (this.toolbar === 'text') {
          this.selectedItem = this.createText(clickEvent.offsetX, clickEvent.offsetY);
          this.selectedItemType = 'text';
        } else if (this.toolbar === 'wall') {
          this.selectedItem = this.createWall(clickEvent.offsetX, clickEvent.offsetY);
          this.selectedItemType = 'wall';
        } else if (this.toolbar === 'railing') {
          this.selectedItem = this.createRailing(clickEvent.offsetX, clickEvent.offsetY);
          this.selectedItemType = 'railing';
        } else {
          this.showItemDetails = false;
          if (this.selectedIndex > -1)
            this.setEditSelected(this.selectedIndex, false);
        }
        if (!clickEvent.ctrlKey)
          this.resetMultiSelection();
      },

      // Create a seat
      createSeat(x, y) {
        let mySlot = {
          x: x,
          y: y,
          slotCategory: { id: this.SLOT_CATEGORY_REGULAR },
          status: 'ACTIVE',
          capacity: 1,
          rowLabel: '',
          slotNumber: '',
          zone: ''
        };
        this.slots.push(mySlot);
        return mySlot;
      },

      // Create a screen
      createScreen(x, y) {
        let screenWidth = 700;
        let myScreen = {
          x: x - Math.floor(screenWidth / 2),
          y: y - 20,
          type: 'SCREEN',
          width: screenWidth,
          label: 'Screen'
        };
        this.uiComponents.push(myScreen);
        return myScreen;
      },

      // Create a wall
      createWall(x, y) {
        let wallWidth = 400, wallHeight = 40;
        let myWall = {
          x: x - Math.floor(wallWidth / 2),
          y: y - Math.floor(wallHeight / 2),
          type: 'WALL',
          width: wallWidth,
          height: wallHeight
        };
        this.uiComponents.push(myWall);
        return myWall;
      },

      // Create a railing
      createRailing(x, y) {
        let railingWidth = 400, railingHeight = 40;
        let myRailing = {
          x: x - Math.floor(railingWidth / 2),
          y: y - Math.floor(railingHeight / 2),
          type: 'RAILING',
          width: railingWidth,
          height: railingHeight
        };
        this.uiComponents.push(myRailing);
        return myRailing;
      },

      // Create a text
      createText(x, y) {
        let myText = {
          x: x - 15,
          y: y - 10,
          type: 'TEXT',
          label: 'Text'
        };
        this.uiComponents.push(myText);
        return myText;
      },

      // Show seats context menu
      showContextMenu (e, item, itemType) {
        this.selectedItem = item;
        this.selectedItemType = itemType;

        // track last two selected slots
        if (itemType === 'seat') {
          this.selectedIndex = this.slots.indexOf(item);
          this.trackSelectedSlots();
          this.trackSelectedSlotIndexes();
        }

        // console.log('I GET HERE+++', this.selectedItem, this.selectedItemType);
        e.preventDefault();
        this.showMenu = false;
        this.cmX = e.clientX;
        this.cmY = e.clientY;
        this.$nextTick(() => {
          this.showMenu = true;
        })
      },

      // Show selected item details menu
      showItemDetailMenu (e, item, index, itemType) {
        if (!e.ctrlKey) {
          this.resetMultiSelection();

          // console.log(e);
          this.selectedItem = item;
          this.selectedItemType = itemType;

          // track last two selected slots
          if (itemType === 'seat') {
            // release previously selected slot if not multi selecting
            if (this.selectedIndex > -1)
              this.setEditSelected(this.selectedIndex, false);

            this.selectedIndex = index;
            this.trackSelectedSlots();
            this.trackSelectedSlotIndexes();
            // console.log("called seat name validator: ", this.selectedItemArray[0], this.selectedIndexArray[0]);

            // validate slot name
            let validationCheck = this.validateSeatNames(this.selectedItemArray[0], this.selectedIndexArray[0]);
            if (validationCheck) {
              this.selectedItem = this.selectedItemArray[0];
              this.selectedIndex = this.selectedIndexArray[0];
              this.trackSelectedSlots();
              this.trackSelectedSlotIndexes();
            }
            // set edit selection on the slot
            this.setEditSelected(this.selectedIndex, true);
          }

          e.preventDefault();
          this.showItemDetails = true;
        }
      },

      // Selected item context menu actions
      seatCMAction(item, action) {
        // console.log('GETS HERE+++', action, this.selectedItemType);
        if (action === 'delete' && this.selectedItemType === 'seat') {
          let seatIndex = this.slots.indexOf(item);
          this.slots.splice(seatIndex, 1);
          if (item.id > 0) {
            this.deletedSlots.push(item);
          }
        } else if (action === 'delete' && ! (this.selectedItemType === 'seat')) {
          let uiCompIndex = this.uiComponents.indexOf(item);
          this.uiComponents.splice(uiCompIndex, 1);
          if (item.id > 0) {
            this.deletedUiComponents.push(item);
          }
        }
      },

      // Update ui component coordinates after it has been moved and/or resized
      uiComponentMoved(e, uiItem) {
        // if (uiItem.x !== e.x || uiItem.y !== e.y) {}
        // console.log('old position: ' + 'x=' + uiItem.x + ' - y=' + uiItem.y);
        uiItem.x = e.x;
        uiItem.y = e.y;
        uiItem.width = (e.width && e.width > 0) ? e.width : uiItem.width;
        uiItem.height = (e.height && e.height > 0) ? e.height : uiItem.height;
        // console.log('new position: ' + 'x=' + uiItem.x + ' - y=' + uiItem.y);
        // console.log(this.uiComponents);
      },

      /* Fetch the list of all Slot Categories form the server */
      getSlotCategories() {
        axios.get(BACKEND_URL+'/api/slot/categories').then(({data})=>{
          this.slotCategories = data;
          // console.log(data);
        }).catch((error)=>{
          if (error.message === 'Network Error') {
            this.displayErrorMessages('Cannot connect to server');
          } else {
            this.displayErrorMessages(error.response.data);
          }
        });
      },

      // validate seat names to prevent duplicate naming
      validateSeatNames(selectedItem, selectedIndex) {
        selectedIndex = (selectedIndex >= 0) ? selectedIndex : this.selectedIndex;
        let newRowLabel = selectedItem.rowLabel.trim(),
          newSlotNumber = selectedItem.slotNumber.trim();
        newRowLabel = (newRowLabel) ? newRowLabel.toLowerCase() : newRowLabel;
        newSlotNumber = (newSlotNumber) ? newSlotNumber.toLowerCase() : newSlotNumber;
        let newSeatName = newRowLabel + newSlotNumber;
        // console.log("gets here: " + newSeatName);

        let slotFound = false,
          slots = this.selectedLayout.slots;
        for (let i = 0; i < slots.length; i++) {
          let slot = slots[i];
          let rowLabel = slot.rowLabel.trim(),
            slotNumber = slot.slotNumber.trim();
          rowLabel = (rowLabel) ? rowLabel.toLowerCase() : rowLabel;
          slotNumber = (slotNumber) ? slotNumber.toLowerCase() : slotNumber;
          let seatName = rowLabel + slotNumber;
          if (seatName && seatName.length > 0 && seatName === newSeatName && selectedIndex !== i) {
            console.log("Duplicate Seat: " + newSeatName + ", selectedIndex: " + selectedIndex + ", loop index: " + i);
            alert("There is already a seat number " + selectedItem.rowLabel + selectedItem.slotNumber + ". Please chose a different seat number.");
            selectedItem.slotNumber = "";
            // this.selectedItem = selectedItem;
            // this.selectedItem.slotNumber = "";
            slotFound = true;
            break;
          }
        }

        return slotFound;
      },

      trackSelectedSlots() {
        if (this.selectedItemArray.length < 2) {
          this.selectedItemArray.push(this.selectedItem);
        } else {
          this.selectedItemArray.splice(0, 1);
          this.selectedItemArray.push(this.selectedItem);
        }
      },

      trackSelectedSlotIndexes() {
        if (this.selectedIndexArray.length < 2) {
          this.selectedIndexArray.push(this.selectedIndex);
        } else {
          this.selectedIndexArray.splice(0, 1);
          this.selectedIndexArray.push(this.selectedIndex);
        }
      },

      // set edit selected on an item
      setEditSelected(slotIndex, value) {
        let mySlot = this.slots[slotIndex];
        mySlot.editSelected = value;
        this.slots.splice(slotIndex, 1, mySlot);
      },

      // Add clicked item to selection
      addToSelection(item, index) {
        if (this.multiSelectedIndexes.length <= 0 && this.selectedItem && this.selectedItem.editSelected)
          this.pushToMultiSelectedIndexes(this.selectedIndex);

        //check if slot index has already been selected and remove it from the selection
        let removedIndex = false;
        for(let i = 0; i < this.multiSelectedIndexes.length; i++) {
          let slotIndex = this.multiSelectedIndexes[i];
          if (slotIndex === index) {
            this.removeFromMultiSelectedIndexes(i);
            removedIndex = true;
            break;
          }
        }
        if (!removedIndex)
          this.pushToMultiSelectedIndexes(index);

        // set item details section visibility
        this.showItemDetails = this.multiSelectedIndexes.length > 0;
        // else if (this.multiSelectedIndexes.length === 0)
        //   this.showItemDetails = false;
        console.log("CTRL Click: ", this.multiSelectedIndexes, index);
        this.getMultiSelectedItem();
      },

      // Reset multi selection array
      resetMultiSelection() {
        if (this.multiSelectedIndexes.length > 0)
          this.multiSelectedIndexes = [];
      },

      // push to multiSelectedIndexes array
      pushToMultiSelectedIndexes(item) {
        let copiedArray = this.multiSelectedIndexes.slice(0);
        copiedArray.push(item);
        this.multiSelectedIndexes = copiedArray;
      },

      // remove the an item from the multiSelectedIndexes array
      removeFromMultiSelectedIndexes(index) {
        let copiedArray = this.multiSelectedIndexes.slice(0);
        copiedArray.splice(index, 1);
        this.multiSelectedIndexes = copiedArray;
      },

      // calculate multiSelectedItem
      getMultiSelectedItem() {
        let selectionCount = this.multiSelectedIndexes.length;
        if (selectionCount === 0) {
          this.multiSelectedItem = JSON.parse(JSON.stringify(this.defaultMultiSelectedItem));
        } else if (selectionCount === 1) {
          this.multiSelectedItem = this.slots[this.multiSelectedIndexes[0]];
        } else {
          this.multiSelectedItem = JSON.parse(JSON.stringify(this.slots[this.multiSelectedIndexes[0]]));
          for (let i = 1; i < selectionCount; i++) {
            let selectedSlot = this.slots[this.multiSelectedIndexes[i]];
            if (this.multiSelectedItem.rowLabel !== selectedSlot.rowLabel)
              this.multiSelectedItem.rowLabel = "";
            if (this.multiSelectedItem.slotCategory.id !== selectedSlot.slotCategory.id)
              this.multiSelectedItem.slotCategory =
                JSON.parse(JSON.stringify(this.defaultMultiSelectedItem.slotCategory));
            if (this.multiSelectedItem.status !== selectedSlot.status)
              this.multiSelectedItem.status = "";
            if (this.multiSelectedItem.repairStartDate !== selectedSlot.repairStartDate)
              this.multiSelectedItem.repairStartDate = "";
            if (this.multiSelectedItem.repairEndDate !== selectedSlot.repairEndDate)
              this.multiSelectedItem.repairEndDate = "";
            if (this.multiSelectedItem.capacity !== selectedSlot.capacity)
              this.multiSelectedItem.capacity = "";
            if (this.multiSelectedItem.zone !== selectedSlot.zone)
              this.multiSelectedItem.zone = "";
            if (this.multiSelectedItem.slotScore !== selectedSlot.slotScore)
              this.multiSelectedItem.slotScore = "";
            if (this.multiSelectedItem.managerReserved !== selectedSlot.managerReserved)
              this.multiSelectedItem.managerReserved = "";
          }
        }
      },

      // update selected items on field change
      updateMultipleItems(fieldName) {
        this.multiSelectedIndexes.forEach(selectedIndex => {
          let slot = this.slots[selectedIndex];
          slot[fieldName] = this.multiSelectedItem[fieldName];
          this.slots.splice(selectedIndex, 1, slot);
        });
      }
    },

    mounted() {
      // this.windowWidth = window.innerWidth;
      // // Set the canvas height and width
      // let canvas = this.$el.querySelector('canvas');
      // canvas.width = window.innerWidth - 50;
      // canvas.height = window.innerHeight - 50;
      //
      // // Draw on the canvas
      // let c = canvas.getContext('2d');
      // c.fillRect(100, 100, 50, 30);
      // // c.fillStyle = "transparent";
      // c.strokeRect(400, 100, 50, 30);
      //
      // console.log(canvas);
    },

    created() {
      this.getSlotCategories();
    },
  }
</script>

<style scoped>
  .c-canvas {
    background: #ffffff;
    /*background: #f3eee6;*/
    /*border: 1px solid black;*/
  }
  .selected-item-details {
    position: fixed;
    right: 30px;
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/FloorPlanDesigner.vue